import React from "react";
import { Alert, Form, Icon, Button, Select, Checkbox, Row, Col } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import {
  getUsersLight,
  copyBulkSiteChangePermissions,
} from "../../api/requests";

import classes from "./CopyUserPermissionsMultiSitesForm.css";
import { logout } from "../../reducers/user/actions";
import uniq from "lodash/uniq";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class CopyUserPermissionsMultiSitesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      users: [],
      rolesKeys: [],
      sitesKeys: [],
      shiftDown: false,
    };
  }

  async componentDidMount() {
    const { data: users } = await getUsersLight();
    this.setState({ users });
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  onTargetKeyChange = (index, id) => (e) => {
    const isChecked = e.target.checked;
    const { sitesKeys, shiftDown } = this.state;
    const { sitesList: sites } = this.props;
    if (sitesKeys.length && shiftDown) {
      const lastCheckedItemIndex = sites.findIndex(
        (item) => item.id === sitesKeys[sitesKeys.length - 1]
      );

      let newItems = [];

      if (lastCheckedItemIndex < index) {
        newItems = sites.reduce((result, item, itemIndex) => {
          return itemIndex > lastCheckedItemIndex && itemIndex <= index
            ? [...result, item.id]
            : result;
        }, []);
      } else {
        newItems = sites.reduce((result, item, itemIndex) => {
          return itemIndex < lastCheckedItemIndex && itemIndex >= index
            ? [...result, item.id]
            : result;
        }, []);
      }

      this.setState(({ sitesKeys }) => ({
        sitesKeys: uniq([...sitesKeys, ...newItems]),
      }));
    } else {
      this.setState(({ sitesKeys }) => ({
        sitesKeys: isChecked
          ? uniq([...sitesKeys, id])
          : uniq(sitesKeys.filter((item) => item !== id)),
      }));
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { sitesKeys } = this.state;

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        if (!sitesKeys.length) {
          this.setState({
            requestResult: {
              type: "warning",
              message: this.props.i18n.t(
                "NamespaceCopyUserPermissionsMultiSitesForm:Please, select role to copy"
              ),
            },
          });
          return;
        }

        this.setState({ isLoading: true });

        try {
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          await copyBulkSiteChangePermissions({
            type: values.type,
            user_id: values.from_user_id,
            role_id: values.role_id,
            site_ids: sitesKeys,
          });

          setTimeout(() => {
            this.props.onSubmit();
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult, users, sitesKeys } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { rolesList, sitesList } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceCopyUserPermissionsMultiSitesForm:Add/remove user permission to multiple sites"
            )}
          </h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceCopyUserPermissionsMultiSitesForm:Source user"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("from_user_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select User")}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {users.map((user) => (
                        <Option
                          key={user.id}
                          value={user.id}
                          disabled={getFieldValue("to_user_id") === user.id}
                        >
                          {user.username}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("Type")}:</b>
                <Form.Item>
                  {getFieldDecorator("type", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t(
                        "NamespaceCopyUserPermissionsMultiSitesForm:Select type"
                      )}
                    >
                      <Option value="add">
                        {this.props.i18n.t(
                          "NamespaceCopyUserPermissionsMultiSitesForm:Add"
                        )}
                      </Option>
                      <Option value="delete">
                        {this.props.i18n.t("Remove")}
                      </Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceCopyUserPermissionsMultiSitesForm:Role"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("role_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select Role")}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {rolesList.map((role) => (
                        <Option key={role.id} value={role.id}>
                          {role.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row>
            <Col>
              {sitesList.length > 0 && (
                <div style={{ paddingBottom: "12px" }}>
                  <label>
                    <Checkbox
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState(() => ({
                            sitesKeys: sitesList.map(({ id }) => id),
                          }));
                        } else {
                          this.setState(() => ({
                            sitesKeys: [],
                          }));
                        }
                      }}
                    />
                    <b>
                      &nbsp; {this.props.i18n.t("Check all")} &nbsp; (
                      {sitesKeys.length}/{sitesList.length})
                    </b>
                  </label>
                </div>
              )}

              {sitesList
                .sort((a, b) => get(a, "code") - get(b, "code"))
                .map(({ id, name, code }, i) => (
                  <div key={id} style={{ paddingBottom: "4px" }}>
                    <label>
                      <Checkbox
                        checked={
                          sitesKeys.findIndex((targetKey) => targetKey === id) >
                          -1
                        }
                        onChange={this.onTargetKeyChange(i, id)}
                      />
                      &nbsp;
                      {code} - {name}
                    </label>
                  </div>
                ))}

              <br />
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
                disabled={isLoading}
              >
                {this.props.i18n.t("Submit")}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
              <Button
                type="default"
                size="large"
                htmlType="button"
                className={classes.submitButton}
                onClick={this.props.onCancel}
              >
                {this.props.i18n.t("Cancel")}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (_) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "drugShip" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(CopyUserPermissionsMultiSitesForm))
);



// WEBPACK FOOTER //
// ./src/components/CopyUserPermissionsMultiSitesForm/CopyUserPermissionsMultiSitesForm.js